import qs from 'qs';
import initData from 'init-data';
import { touchWebClient } from 'tradera/utils/http';

const checkUserMessagingParticipation = (sellerId) =>
    touchWebClient
        .get('messaging/participation/' + sellerId)
        .then((response) => !!response.data.participates);

const setUserMessagingParticipation = (messagingSettings) =>
    touchWebClient
        .post('/my/profile/messaging-participation', messagingSettings)
        .then((response) => response.data);

const setUserMessagingEmailSetting = async (setting) =>
    touchWebClient
        .post('/api/messaging/emailnotify?emailNotify=' + setting)
        .then((response) => response.data);

/**
 * Returns base path for a thread
 *
 * @param {number} u1
 * @param {number} u2
 * @param {number} l
 * @param {object} [options]
 * @param {boolean} [options.singleThread] - Open in single thread mode
 * @param {boolean} [options.openForm] - Open message form right away
 * @param {string} [options.source] - Message source info for tracking
 * @returns {string}
 */
const getMessagingThreadLink = (u1, u2, l, options) => {
    const optionsWithDefaults = {
        singleThread: false,
        openForm: false,
        ...options
    };
    const { singleThread, ...queryParams } = optionsWithDefaults;
    return (
        (singleThread ? '/thread/' : '/threads/') +
        'u' +
        Math.min(u1, u2) +
        '_u' +
        Math.max(u1, u2) +
        '_l' +
        l +
        qs.stringify(queryParams, { addQueryPrefix: true })
    );
};

/**
 * Returns the path to a thread on Tradera's messaging page
 *
 * @param {number} u1
 * @param {number} u2
 * @param {number} l
 * @param {object} [options]
 * @returns {string}
 */
const getMessagingPageLink = (u1, u2, l, options) =>
    'messaging' +
    (u1 && u2 && l ? getMessagingThreadLink(u1, u2, l, options) : '');

/**
 * Get messaging url
 *
 * @returns {string}
 */
const getMessagingRemoteUrl = () => {
    return initData.messagingIframeUrl;
};

export {
    checkUserMessagingParticipation,
    setUserMessagingParticipation,
    setUserMessagingEmailSetting,
    getMessagingPageLink,
    getMessagingThreadLink,
    getMessagingRemoteUrl
};
